module.exports = __webpack_public_path__ + "img/mt21.bc24caff.jpg";